import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { analityka } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/analityka";

export const Route = createFileRoute("/integracje/analityka")({
  head: () =>
    buildSeoMeta({
      title: "Wdrożenia GA4, Tag Manager, Pixel, Conversions API | SyncTech",
      description:
        "Konfiguracja Google Analytics 4, Google Tag Manager (server-side), Facebook Pixel + Conversions API, tracking konwersji Google Ads. Atrybucja multi-touch, dashboardy Looker.",
      path: PATH,
    }),
  component: () => <PlatformPage data={analityka} path={PATH} breadcrumbCategory="Integracje" />,
});
